import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Bagaimana cara melakukan test ride motor Honda?',
      answer: 'Anda dapat melakukan test ride dengan menghubungi kami terlebih dahulu melalui WhatsApp atau telepon untuk membuat janji. Bawa KTP asli dan SIM C yang masih berlaku. Test ride tersedia setiap hari Senin-Sabtu pukul 09:00-16:00 WIB.',
    },
    {
      question: 'Apakah tersedia layanan trade-in motor lama?',
      answer: 'Ya, kami menerima trade-in motor lama Anda. Tim kami akan melakukan penilaian kondisi motor dan memberikan harga terbaik. Proses trade-in dapat langsung mengurangi harga pembelian motor baru Anda.',
    },
    {
      question: 'Berapa lama proses persetujuan kredit motor?',
      answer: 'Proses persetujuan kredit biasanya memakan waktu 1-3 hari kerja setelah dokumen lengkap diterima. Untuk mempercepat proses, pastikan semua dokumen yang diperlukan sudah lengkap dan sesuai.',
    },
    {
      question: 'Apa saja dokumen yang diperlukan untuk kredit motor?',
      answer: 'Dokumen yang diperlukan: KTP asli dan fotokopi, Kartu Keluarga, slip gaji atau bukti penghasilan 3 bulan terakhir, rekening koran 3 bulan terakhir, dan NPWP (jika ada). Untuk wiraswasta, diperlukan dokumen tambahan seperti SIUP atau bukti usaha.',
    },
    {
      question: 'Apakah ada garansi untuk motor Honda?',
      answer: 'Semua motor Honda baru dilengkapi dengan garansi resmi dari PT Astra Honda Motor selama 3 tahun atau 30.000 km (mana yang tercapai lebih dulu). Garansi mencakup suku cadang dan jasa service berkala di bengkel resmi Honda.',
    },
    {
      question: 'Bagaimana cara booking service motor?',
      answer: 'Anda dapat booking service melalui website kami di menu Booking Service, atau hubungi kami via WhatsApp/telepon. Kami juga menyediakan layanan home service untuk area tertentu dengan biaya tambahan.',
    },
    {
      question: 'Apakah suku cadang yang digunakan original?',
      answer: 'Ya, kami hanya menggunakan suku cadang original Honda (Genuine Parts) untuk semua layanan service dan perbaikan. Semua suku cadang dilengkapi dengan garansi resmi dari Honda.',
    },
    {
      question: 'Berapa biaya service berkala motor Honda?',
      answer: 'Biaya service berkala bervariasi tergantung tipe motor dan jenis service (1000 km, 4000 km, 8000 km, dst). Untuk informasi detail biaya service, silakan hubungi customer service kami atau kunjungi halaman Booking Service.',
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="container mx-auto px-4" data-aos="fade-up" data-aos-delay="150" >
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-3 md:mb-4">
            Pertanyaan yang Sering Diajukan
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Temukan jawaban untuk pertanyaan umum seputar produk dan layanan Honda Pamulang
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-3 md:space-y-4">
            {faqs?.map((faq, index) => (
              <div
                key={index}
                className="bg-card rounded-xl border border-border overflow-hidden transition-all duration-300 hover:shadow-card-hover"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between p-4 md:p-6 text-left transition-colors duration-200 hover:bg-muted"
                >
                  <span className="text-sm md:text-base lg:text-lg font-heading font-semibold text-foreground pr-4">
                    {faq?.question}
                  </span>
                  <div
                    className={`flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-lg bg-primary/10 flex items-center justify-center transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  >
                    <Icon 
                      name="ChevronDown" 
                      size={20} 
                      color="var(--color-primary)" 
                    />
                  </div>
                </button>

                <div
                  className={`transition-all duration-300 ease-in-out ${
                    openIndex === index
                      ? 'max-h-96 opacity-100' :'max-h-0 opacity-0'
                  } overflow-hidden`}
                >
                  <div className="px-4 md:px-6 pb-4 md:pb-6">
                    <div className="pt-4 border-t border-border">
                      <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                        {faq?.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 md:mt-12 bg-gradient-to-br from-primary to-accent rounded-xl p-6 md:p-8 text-white text-center" data-aos="zoom-in-up" data-aos-delay="150" >
            <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-white/20 backdrop-blur-sm rounded-xl mb-4 md:mb-6">
              <Icon name="HelpCircle" size={28} color="white" />
            </div>

            <h3 className="text-lg md:text-xl lg:text-2xl font-heading font-bold mb-2 md:mb-3">
              Masih Ada Pertanyaan?
            </h3>

            <p className="text-sm md:text-base text-white/90 mb-6 md:mb-8 max-w-2xl mx-auto">
              Tim customer service kami siap membantu menjawab semua pertanyaan Anda
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
              <a
                href="https://wa.me/6281234567890?text=Halo,%20saya%20memiliki%20pertanyaan%20tentang%20Honda%20Pamulang"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 px-6 md:px-8 py-3 md:py-4 bg-white text-primary rounded-lg font-heading font-semibold text-sm md:text-base hover:bg-white/90 transition-all duration-300 shadow-lg w-full sm:w-auto justify-center"
              >
                <Icon name="MessageCircle" size={20} />
                <span>Chat WhatsApp</span>
              </a>

              <a
                href="tel:+6281234567890"
                className="inline-flex items-center space-x-2 px-6 md:px-8 py-3 md:py-4 bg-white/10 backdrop-blur-sm text-white rounded-lg font-heading font-semibold text-sm md:text-base hover:bg-white/20 transition-all duration-300 border border-white/30 w-full sm:w-auto justify-center"
              >
                <Icon name="Phone" size={20} />
                <span>Telepon Kami</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;